import { DISPATCH_EVENT3, DISPATCH_EVENT3_SUCCESS } from "../constants";

export const dispatchEvent3 = ({
  pageType,
  pageId,
  nodeId,
  event,
  context,
  clientStatus,
}) => {
  return {
    type: DISPATCH_EVENT3,
    pageType,
    pageId,
    nodeId,
    event,
    context,
    clientStatus,
  };
};

export const dispatchEvent3Success = (props) => {
  const { data, warnings, errors, _id } = props;
  return {
    type: DISPATCH_EVENT3_SUCCESS,
    data,
    errors,
    warnings,
    _id,
  };
};
